module.exports = __webpack_public_path__ + "img/bank-slip.bc112741.svg";